import Colors from "../../../theme/colors";

const Styles = {
  typography: {
    color: "#1F26C7",
    marginBottom: 25,
    fontSize: 16,
    fontWeight: 500,
  },

  gridStyle: {
    marginTop: 5,
    marginBottom: 15,
  },

  typographySecondary: {
    marginTop: 20,
    marginBottom: 20,
  },

  buttonStyle: {
    marginTop: 100,
    backgroundColor: Colors.midnightBlue,
    borderRadius: 100,
    width: 150,
    height: 52,
    marginRight: "50%",
  },

  zoneLocatorContainer: {
    display: "flex",
    justifyContent: "row",
    alignItems: "center",
    fontSize: "22px",
    marginTop: "30px",
    cursor: "pointer",
  },

  inputField: {
    marginBottom: 20,
    width: "100%",
  },
};

export default Styles;
